import { CompensationTypeLabel } from '@modules/EvaluationModule/enums/CompensationTypeLabel';
import { HistoricalCompensationData } from '@modules/EvaluationModule/interfaces/CompensationData';
import {
  formatFinancialValue,
  isUnderReview,
  UNDER_REVIEW_LABEL,
} from '@modules/EvaluationModule/pages/UserCompensationPage/helpers/currencyOptions';
import { Typography } from '@mui/material';
import React, { FC } from 'react';

interface Props {
  compensation: HistoricalCompensationData;
}

export const CompensationDetailsModalMoney: FC<Props> = ({ compensation }) => {
  if (isUnderReview(compensation.currentCompensation)) {
    return (
      <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
        {UNDER_REVIEW_LABEL}
      </Typography>
    );
  }

  return (
    <span>
      <Typography component="span" variant="body2">
        $
      </Typography>
      {formatFinancialValue(compensation.currentCompensation)}
      {CompensationTypeLabel[compensation.compensationType as keyof typeof CompensationTypeLabel]}
    </span>
  );
};
